import { ELEMENTAR_BASE_URL, GPT_BASE_URL } from '../../apiRoutes';
import { http, handleErrors } from '../../services/http-wrapper';
import { Auth } from 'aws-amplify';

export const ApiPostLegalBase = async ({
  initial_date,
  final_date,
  cnpj,
  nat_oper,
  market,
  estab_rem,
  tributation
}) => {
  let data = {
    initial_date: initial_date,
    final_date: final_date,
    cnpj: cnpj,
    nat_oper: nat_oper,
    market: market,
    estab_rem: estab_rem,
    tributation: tributation
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/legal_base/execution`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNCMList = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/legal_base/get/ncm_distinct`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNCMInfo = async ({ cnpj, ncm }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/legal_base/get/ncm_result?cnpj=${cnpj}&ncm=${ncm}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// Tax Information Page
export const ApiGetTaxInformationSP = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${GPT_BASE_URL}/doe_sp/disponibledays`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetTaxInformationUniao = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${GPT_BASE_URL}/dou/disponibledays`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostTaxInformationUniao = async ({
  days,
  organizacao,
  organizacao_subordinada,
  tipoato,
  page_size,
  page
}) => {
  //1
  let filtersForOrgSubsAto = {
    active: 'true',
    organizacao: organizacao?.length > 0 ? organizacao : 'Todos',
    organizacao_subordinada:
      organizacao_subordinada?.length > 0 ? organizacao_subordinada : 'Todos',
    tipoato: tipoato?.length > 0 ? tipoato : 'Todos',
    page_size,
    page
  };
  //2
  let data = {
    days: days,
    filtero_dou: filtersForOrgSubsAto
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/dou/filter`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostTaxInformationSP = async ({
  days,
  caderno,
  secao,
  page_size,
  page
}) => {
  // testa se há filtros preenchidos
  // let isFilter = caderno || secao ? true : false;
  // objeto dentro de um atributo do objeto do body
  let filtersCadernoSecao = {
    active: 'true',
    caderno: caderno?.length > 0 ? caderno : 'Todos',
    secao: secao?.length > 0 ? secao : 'Todos',
    page_size,
    page
  };
  // outra opção para o objeto
  /*
  let noFiltersCadernoSecao = {
    active: 'false'
  };
  */
  // objeto do body
  let data = {
    days: days,
    filtero_doe_sp: filtersCadernoSecao
  };
  // filtero_doe_sp: isFilter ? filtersCadernoSecao : noFiltersCadernoSecao
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/doe_sp/filter`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptUniaoQuestion = async ({
  pergunta,
  diario_oficial,
  days,
  organizacao,
  organizacao_subordinada,
  tipoato,
  page_size,
  page
}) => {
  let filtersForOrgSubsAto = {
    active: 'true',
    organizacao: organizacao?.length > 0 ? organizacao : 'Todos',
    organizacao_subordinada:
      organizacao_subordinada?.length > 0 ? organizacao_subordinada : 'Todos',
    tipoato: tipoato?.length > 0 ? tipoato : 'Todos',
    page_size,
    page
  };
  let data = {
    pergunta: pergunta,
    diario_oficial: diario_oficial,
    days: days,
    filtero_dou: filtersForOrgSubsAto
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/store_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptSPQuestion = async ({
  pergunta,
  diario_oficial,
  days,
  caderno,
  secao,
  page_size,
  page
}) => {
  let filtersCadernoSecao = {
    active: 'true',
    caderno: caderno?.length > 0 ? caderno : 'Todos',
    secao: secao?.length > 0 ? secao : 'Todos',
    page_size,
    page
  };
  let data = {
    pergunta: pergunta,
    diario_oficial: diario_oficial,
    days: days,
    filtero_doe_sp: filtersCadernoSecao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/store_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptUniaoResponse = async ({
  pergunta,
  diario_oficial,
  days,
  organizacao,
  organizacao_subordinada,
  tipoato,
  page_size,
  page
}) => {
  let filtersForOrgSubsAto = {
    active: 'true',
    organizacao: organizacao?.length > 0 ? organizacao : 'Todos',
    organizacao_subordinada:
      organizacao_subordinada?.length > 0 ? organizacao_subordinada : 'Todos',
    tipoato: tipoato?.length > 0 ? tipoato : 'Todos',
    page_size,
    page
  };
  let data = {
    pergunta: pergunta,
    diario_oficial: diario_oficial,
    days: days,
    filtero_dou: filtersForOrgSubsAto
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/find_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptSPResponse = async ({
  pergunta,
  diario_oficial,
  days,
  caderno,
  secao,
  page_size,
  page
}) => {
  let filtersCadernoSecao = {
    active: 'true',
    caderno: caderno?.length > 0 ? caderno : 'Todos',
    secao: secao?.length > 0 ? secao : 'Todos',
    page_size,
    page
  };
  let data = {
    pergunta: pergunta,
    diario_oficial: diario_oficial,
    days: days,
    filtero_doe_sp: filtersCadernoSecao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/find_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
